import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { getConfig } from '../get-import-config'
import BaseActionButton from '../../Page/BaseActionButton'
import Modal from '../../Modal'
import ImportTeamRosterContent from './ImportTeamRosterContent'

const ImportTeamRoster = ({
  teamId,
  teamName,
  teamRosterId,
  onSuccess,
  orgId,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const importTemplate = orgId
    ? getConfig().multiTeamRoster
    : getConfig().roster

  const onToggle = () => {
    setIsOpen(!isOpen)
  }

  const link = (
    <BaseActionButton
      name={orgId ? 'multi-roster' : 'upload'}
      title={importTemplate?.label}
      onClick={onToggle}
      disabled={loading}
      busy={loading}
    />
  )

  return (
    <>
      {link}
      <Modal
        isOpen={isOpen}
        onClose={onToggle}
        shouldCloseOnOverlayClick={false}
      >
        {isOpen && (
          <ImportTeamRosterContent
            setLoading={setLoading}
            loading={loading}
            toggle={onToggle}
            importTemplate={importTemplate}
            teamName={teamName}
            teamRosterId={teamRosterId}
            teamId={teamId}
            onSuccess={onSuccess}
            orgId={orgId}
          />
        )}
      </Modal>
    </>
  )
}

ImportTeamRoster.propTypes = {
  teamId: PropTypes.string.isRequired,
  teamName: PropTypes.string.isRequired,
  teamRosterId: PropTypes.string.isRequired,
}

export default ImportTeamRoster
